










import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ArticleTrueCostTable from '@subventions/components/tables/article-true-cost-table/article-true-cost-table.vue';

@Component({
  name: 'bpc-article-true-costs',
  components: {
    'bpc-article-true-cost-table': ArticleTrueCostTable,
  },
})
export default class ArticleTrueCosts extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
